<div class="flex-auto input-field-container {{field.customClass}}" *ngIf="field">
	<label [hidden]="field.UIOptions && field.UIOptions.showLabel === false">{{ fieldOptions.label || field.DisplayText }}</label>

	<p-calendar
		[dateFormat]="field.UIOptions?.CalendarComponent?.dateFormat"
		[formControl]="control"
		[inline]="field.UIOptions?.CalendarComponent?.inline"
		[showWeek]="field.UIOptions?.CalendarComponent?.showWeek || true"
		[selectionMode]="field.UIOptions?.CalendarComponent?.selectionMode || 'single'"
		(onClose)="onClosePanel($event)"
		[showIcon]="true"
		icon="pi pi-calendar"
	></p-calendar>
</div>
